import { getRequestConfig } from 'next-intl/server'
import { notFound } from 'next/navigation'

export const locales = ['en', 'ru', 'hy']

export default getRequestConfig(async ({ requestLocale }) => {
  let locale = await requestLocale;

  if (!locales.includes(locale as any)) notFound()

  return {
    locale,
    messages: (await import(`../messages/${locale}.json`)).default
  }
})
